module.exports = __webpack_public_path__ + "img/ibdpro-white-logo.ce70315f.svg";